/**
 *
 */




class StorageOperator {

	constructor() {

		this._STATE_CATEG = [  'or34', 'userCu', 'userSe'  ];

	};

	/**
	 * 引数を基に、keyのストレージがあるかどうか判定
	 * 戻り値  全てが存在していれば True, 一つでも存在していなければ False
	 */
	static isNotStorageData(sumStorage, ...keys) {
		let boo = true;
		for(let i=0; i<keys.length; i++) {
			let json = StorageOperator.getStorageData(sumStorage, keys[i]);
			if(!json) {  boo = false;  };
		};
		return boo;
	};
	/**
	 * 引数を基に、keyのストレージがあるかどうか判定
	 * 戻り値  判定した結果を、引数の並び順の配列に格納し返す
	 */
	static isArrayStorageData(sumStorage, ...keys) {
		let boo = [];
		for(let i=0; i<keys.length; i++) {
			let json = StorageOperator.getStorageData(sumStorage, keys[i]);
			if(json) {
				boo.push( true );
			}else {
				boo.push( false );
			};
		};
		return boo;
	};


	static getStorageData(sumStorage, keyName) {

		if(sumStorage==='session') {

			return JSON.parse( sessionStorage.getItem( keyName ) );

		}else if(sumStorage==='local'){
			return JSON.parse( localStorage.getItem( keyName ) );
		}else {
			throw new Error("HttpStorageOperator.getStorageData()：第一引数が不正です");
		};

	};


	/**
	 * ストレージへ データ格納
	 * 戻り値 データの格納に成功したかどうか
	 */
	static setStorageData(sumStorage, keyName, jsonObj) {

		let storage = null;

		if(sumStorage==='session') {

			storage = sessionStorage || null;
		}else if(sumStorage==='local'){

			storage = localStorage || null;
		}else {
			throw new Error("HttpStorageOperator.getStorageData()：第一引数が不正です");
		};

		if(storage==null) {
			throw new Error(sumStorage+'Storageが使えません');
		};
		let boo = [true, true];

		try {
			storage.setItem(keyName, JSON.stringify( jsonObj ));
		} catch(domException) {
			if (domException.name === 'QuotaExceededError' ||
				domException.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
				console.log("sessionStorage Over です");
				boo[1] = false;
			};
			boo[0] = false;
		};

		return boo;
	};





	static makeObjList(...obj) {
		let array = [];
		for(let i=0, n=obj.length; i<n; i++) {
			array.push(obj[i]);
		};
		return array;
	}

	static makePageStateJson( or34, userCuObj, userSeList ) {

		let state = StorageOperator.getStorageData('session', 'state');
		if(!state) {   state = {};   };

		let json = {};

		switch(arguments.length) {
		  case 3:
			  json.or34 = or34;
			  json['userCu'+or34] = userCuObj;
			  json['userSe'+or34] = userSeList;
			  break;
		  case 2:
			  json.or34 = or34;
			  json['userCu'+or34] = userCuObj;
			  json['userSe'+or34] = state['userSe'+or34] || null;
			  break;
		  case 1:
			  json.or34 = or34;
			  json['userCu'+or34] = state['userCu'+or34] || null;
			  json['userSe'+or34] = state['userSe'+or34] || null;
			  break;
		  default:
			  throw new Error('引数の数が不正です');
		};


		let or34B = ( or34===3 ) ? 4 : 3;
		json['userCu'+or34B] = state['userCu'+or34B] || null;
		json['userSe'+or34B] = state['userSe'+or34B] || null;

		json.coeffValue = state.coeffValue;

		json.poolCateg = state.poolCateg;

		json.theme = state.theme;

		return json;
	};


	static storageSetProperty(  objKey, value, storageKey='state', storage='session' ) {

		let obj = StorageOperator.getStorageData( storage, storageKey);

		if(obj) {
			obj[objKey] = value;
		}else {
			obj = {};
			obj[objKey] = value;
		};

		return StorageOperator.setStorageData( storage, storageKey, obj);
	};




	static removeStorage( storageName, keyName ) {

		if(storageName==='session') {
			sessionStorage.removeItem(keyName);
		}else if(storageName==='local') {
			localStorage.removeItem(keyName);
		};
	};



};

